import "core-js/modules/es.string.replace";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { CmsModules, CmsModuleShape } from 'containers/CmsPage/CmsModules';
export var CmsLayout = function CmsLayout(_ref) {
  var _classNames;

  var activateAt = _ref.activateAt,
      direction = _ref.direction,
      modules = _ref.modules,
      pattern = _ref.pattern,
      hasGutter = _ref.hasGutter;
  // Convert pattern to its css-valid equivalent
  var cssPattern = (pattern || '').replace(/:/g, '-');
  var layoutClasses = classNames((_classNames = {
    CmsLayout: true
  }, _defineProperty(_classNames, "CmsLayout--activate-at-".concat(activateAt), activateAt), _defineProperty(_classNames, "CmsLayout--direction-".concat(direction), direction), _defineProperty(_classNames, "CmsLayout--pattern-".concat(cssPattern), cssPattern), _defineProperty(_classNames, 'CmsLayout--with-gutter', hasGutter), _classNames));
  return React.createElement("div", {
    className: layoutClasses
  }, React.createElement(CmsModules, {
    modules: modules
  }));
};
CmsLayout.propTypes = {
  activateAt: PropTypes.oneOf(['phone', 'tablet', 'desktop']),
  direction: PropTypes.oneOf(['left-to-right', 'right-to-left']),
  modules: PropTypes.arrayOf(CmsModuleShape).isRequired,
  pattern: PropTypes.oneOf(['1', '1:1', '1:2', '2:1', 'phone:1', '1:phone']),
  hasGutter: PropTypes.bool
};